module.exports = __webpack_public_path__ + "img/flag.3359afe2.svg";